import Crud from '../views/MessageType/Crud'
import Entity from '../views/MessageType/Add'


let routes = {
    path: '/message_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/message_types/add',
            name: 'NewMessageType',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de Mensagem',
                breadcrumb: [
                    {
                        text: 'Tipos de Mensagem',
                        active: false,
                        to: '/message_types',
                    },
                    {
                        text: 'Adicionar tipo de Mensagem',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/message_types/edit/:id?',
            name: 'EditMessageType',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de Mensagem',
                breadcrumb: [
                    {
                        text: 'Tipos de Mensagem',
                        active: false,
                        to: '/message_types',
                    },
                    {
                        text: 'Editar tipo de Mensagem',
                        active: true,
                    }
                ],
            }, 
        },
        {
            path: '/message_types',
            name: 'list-message-types',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Tipos de Mensagem',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
